
import { Module } from '../core';

export default class ModuleProject extends Module {

    constructor() {
        super('project');
        this._serverApiUrl = '';
    }

    getServerApiUrl() {
        return this._serverApiUrl;
    }

    async init(options) {
        super.init(options);
        this._serverApiUrl = options.serverApiUrl;
    }
}
